import React, { useState } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {
  AddFeatureRequest,
  AddFeatureRequestFeatureNameEnum,
} from "../../../services/models";
import apiClient from "../../../utils/api";

interface AddClassFeatureProps {
  classes: string[];
  fetchClassFeatures: (classId: string) => void;
}

const AddClassFeature: React.FC<AddClassFeatureProps> = ({
  classes,
  fetchClassFeatures,
}) => {
  const [classId, setClassId] = useState("");
  const [featureName, setFeatureName] =
    useState<AddFeatureRequestFeatureNameEnum>();
  const [validUntil, setValidUntil] = useState<Date | null>(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const addClassFeature = async () => {
    if (!featureName) {
      console.error("Feature name is required");
      return;
    }
    const request: AddFeatureRequest = {
      featureName,
      targetId: classId,
      validUntil: validUntil ?? undefined,
    };
    try {
      await apiClient.featureFlagsControllerAddClassFeature({
        addFeatureRequest: request,
      });
      fetchClassFeatures(classId);
    } catch (error: any) {
      setErrorMessage(
        error.message || "An error occurred while adding the feature."
      );
      setErrorDialogOpen(true);
    }
  };

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false);
    setErrorMessage("");
  };

  return (
    <Grid item xs={12} md={6}>
      <Typography variant="h6">Add Feature Flag to Class</Typography>
      <TextField
        select
        label="Class ID"
        value={classId}
        onChange={(e) => setClassId(e.target.value)}
        fullWidth
      >
        {classes.map((classId) => (
          <MenuItem key={classId} value={classId}>
            {classId}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Feature Name"
        value={featureName}
        onChange={(e) =>
          setFeatureName(e.target.value as AddFeatureRequestFeatureNameEnum)
        }
        fullWidth
      >
        {Object.values(AddFeatureRequestFeatureNameEnum).map((name) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        InputLabelProps={{ shrink: true }}
        label="Valid Until"
        type="datetime-local"
        value={validUntil ? validUntil.toISOString().slice(0, -1) : ""}
        onChange={(e) =>
          setValidUntil(e.target.value ? new Date(e.target.value) : null)
        }
        fullWidth
      />
      <Button variant="contained" color="primary" onClick={addClassFeature}>
        Add Feature to Class
      </Button>
      <Dialog open={errorDialogOpen} onClose={handleErrorDialogClose}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText>{errorMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrorDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default AddClassFeature;
